// extracted by mini-css-extract-plugin
module.exports = {"unidadesDisabledLabel":"MenuSubunidades_unidadesDisabledLabel__1oqnA","marcarTodasSubUnidades":"MenuSubunidades_marcarTodasSubUnidades__UJzD7"};